import React from "react";
import { Box, Button, Typography, Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

interface ApplyFiltersButtonProps {
  disabled: boolean;
  onClick: () => void;
}

const ApplyFiltersButton: React.FC<ApplyFiltersButtonProps> = ({
  disabled,
  onClick,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      {disabled && (
        <Typography
          variant="body2"
          sx={{
            color: "error.main",
            fontSize: "0.75rem",
            fontWeight: 500,
            fontStyle: "italic",
          }}
        >
          Please select a table to search
        </Typography>
      )}
      <Tooltip
        title={
          disabled
            ? "Please select a table before searching"
            : "Apply filters to search"
        }
        arrow
        placement="left"
      >
        <span>
          <Button
            variant="contained"
            size="large"
            onClick={onClick}
            data-testid="retrieve-button"
            disabled={disabled}
            startIcon={<SearchIcon />}
            sx={{
              height: 48,
              fontWeight: 600,
              borderRadius: 2,
              textTransform: "none",
              fontSize: "0.9rem",
              px: 4,
              background: "linear-gradient(135deg, #0097a7 0%, #00838f 100%)",
              color: "white",
              boxShadow: "0 4px 12px rgba(0, 151, 167, 0.3)",
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 6px 16px rgba(0, 151, 167, 0.4)",
                background: "linear-gradient(135deg, #00838f 0%, #006064 100%)",
              },
              "&:active": {
                transform: "translateY(0)",
              },
              "&:disabled": {
                background: "linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 100%)",
                color: "rgba(0, 0, 0, 0.26)",
                boxShadow: "none",
                cursor: "not-allowed",
                opacity: 0.6,
              },
            }}
          >
            Apply filters
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};

export default ApplyFiltersButton;
